<template>
  <div
    class="BoxFilho mb-4">
    <div class="BoxFilho_header p-2">
      <h3 class="BoxFilho_header_title">
        {{ propIndex + 1 }}º - {{ propFilho.nome }}
      </h3>
    </div>

    <div class="BoxFilho_body px-3 py-2">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="d-inline-flex BoxFilho_body_content">
          <div class="d-inline-block mr-5">
            <ul class="BoxFilho_list">
              <li class="BoxFilho_list_item BoxFilho_list_title">
                Interditado
              </li>

              <li class="BoxFilho_list_item">
                <strong>{{ propFilho.interditado ? 'Sim' : 'Não' }}</strong>
              </li>
            </ul>
          </div>
          <div class="d-inline-block mr-5">
            <ul class="BoxFilho_list">
              <li class="BoxFilho_list_item BoxFilho_list_title">
                Falecido
              </li>

              <li class="BoxFilho_list_item">
                <strong>{{ propFilho.falecido ? 'Sim' : 'Não' }}</strong>
              </li>
            </ul>
          </div>

          <div class="d-inline-block mr-5">
            <ul class="BoxFilho_list">
              <li class="BoxFilho_list_item BoxFilho_list_title">
                Idade
              </li>

              <li v-if="propFilho.idade_tipo != 'I'"
                  class="BoxFilho_list_item">
                <strong>{{ getIdade() }}</strong>
              </li>
              <li v-else
                  class="BoxFilho_list_item">
                <strong>Ignorada</strong>
              </li>
            </ul>
          </div>
        </div>

        <div class="">
          <div v-if="!noEditButton"
               class="row no-gutters justify-content-end align-items-center">
            <div class="d-inline-block">
              <button
                type="button"
                class="btn btn-sm btn-danger mr-2"
                @click="$emit('remove', propFilho, propIndex)">
                Remover
              </button>

              <button
                class="btn btn-sm btn-primary"
                type="button"
                @click="$emit('edit', propFilho)">
                Editar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import tipoIdade from "@/constants/tiposIdade"

  export default {
    name: 'BoxFilho',
    props: {
      propFilho: { type: Object, default: ()=>{} },
      noEditButton: Boolean,
      propIndex: Number,
    },
    data () {
      return {
        tipoIdade: tipoIdade
      }
    },
    methods: {
      getIdade () {
        if (this.propFilho.idade) {
          return `${this.propFilho.idade} ${ tipoIdade.find(tipo => tipo.short == this.propFilho.idade_tipo).name}`
        } else {
          return 'Não informado'
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/_exports';

  .BoxFilho {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_header {
      background-color: #01AEC9;
      color: $color-dark;

      &_title {
        font-size: pxToRem(14);
        font-weight: 500;
      }
    }

    &_body {
      &_content {}
    }

    &_list {
      font-size: pxToRem(14);
      list-style: none;
      margin: 0;
      padding: 0;

      &_item {}

      &_title {
        margin-bottom: pxToRem(4);
        text-decoration: underline;
      }
    }
  }
</style>
